export interface MasonryOptions {
  itemSelector: string;
  minColumnWidth: number;
  gap: number;
  maxColumns?: number;
}

export function layoutMasonryGrid(
  grid: HTMLElement,
  options: MasonryOptions
): void {
  const items = Array.from(
    grid.querySelectorAll<HTMLElement>(options.itemSelector)
  ).filter(item => item.offsetParent !== null);

  if (!items.length) {
    grid.style.height = '0px';
    return;
  }

  const styles = getComputedStyle(grid);
  const paddingLeft = parseFloat(styles.paddingLeft || '0');
  const paddingRight = parseFloat(styles.paddingRight || '0');

  const innerWidth = grid.clientWidth - paddingLeft - paddingRight;
  if (innerWidth <= 0) return;

  const { gap, minColumnWidth } = options;

  let columnCount = Math.max(
    1,
    Math.floor((innerWidth + gap) / (minColumnWidth + gap))
  );

  if (options.maxColumns) {
    columnCount = Math.min(columnCount, options.maxColumns);
  }

  const columnWidth =
    (innerWidth - (columnCount - 1) * gap) / columnCount;

  const columnHeights = new Array(columnCount).fill(0);

  for (const item of items) {
    item.style.position = 'absolute';
    item.style.width = `${columnWidth}px`;
    item.style.top = '0';
    item.style.left = '0';
  }

  for (const item of items) {
    let targetColumn = 0;

    for (let i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[targetColumn]) {
        targetColumn = i;
      }
    }

    const x = paddingLeft + targetColumn * (columnWidth + gap);
    const y = columnHeights[targetColumn];

    item.style.transform = `translate(${x}px, ${y}px)`;
    columnHeights[targetColumn] = y + item.offsetHeight + gap;
  }

  const maxHeight = Math.max(...columnHeights);
  grid.style.height = `${Math.max(0, maxHeight - gap)}px`;
}
